import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ThingsToDo from "../pages/things-to-do/page";
import BestLuxuryCabins from "../pages/best-luxury-cabins/page";
import DogFriendlyHighlands from "../pages/dog-friendly-highlands/page";
import PetFriendlyCabins from "../pages/pet-friendly-cabins/page";
import CabinsNearGlenFalls from "../pages/cabins-near-glen-falls/page";
import CabinsInHighlands from "../pages/cabins-in-highlands/page";
import VacationRentalsHighlandsNC from "../pages/vacation-rentals-highlands-nc/page";
import PlacesToStayHighlandsNC from "../pages/places-to-stay-highlands-nc/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/things-to-do",
    element: <ThingsToDo />,
  },
  {
    path: "/best-luxury-cabins",
    element: <BestLuxuryCabins />,
  },
  {
    path: "/dog-friendly-highlands-nc",
    element: <DogFriendlyHighlands />,
  },
  {
    path: "/pet-friendly-cabins-highlands-nc",
    element: <PetFriendlyCabins />,
  },
  {
    path: "/cabins-near-glen-falls-highlands-nc",
    element: <CabinsNearGlenFalls />,
  },
  {
    path: "/cabins-in-highlands-nc",
    element: <CabinsInHighlands />,
  },
  {
    path: "/vacation-rentals-highlands-nc",
    element: <VacationRentalsHighlandsNC />,
  },
  {
    path: "/places-to-stay-highlands-nc",
    element: <PlacesToStayHighlandsNC />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
